import React from "react";

import {
  Box,
  Button,
  IconButton,
  Popover,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: 380,
    maxWidth: "calc(100vw - 24px)",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow:
      theme.palette.type === "dark"
        ? "0 18px 48px rgba(0, 0, 0, 0.42)"
        : "0 18px 48px rgba(15, 23, 42, 0.16)",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 1.5, 1),
  },
  title: {
    fontWeight: 600,
  },
  description: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    fontSize: "0.78rem",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.25),
    padding: theme.spacing(1, 1.5, 1.5),
  },
  actions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
  },
}));

const FilterPopover = ({
  id,
  open,
  anchorEl,
  title = "Filtros",
  description = "Ajuste os critérios e aplique quando estiver pronto.",
  children,
  onClear,
  onApply,
  onClose,
  clearDisabled = false,
  applyLabel = "Aplicar filtros",
}) => {
  const classes = useStyles();
  const titleId = `${id}-title`;

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{
        className: classes.paper,
        role: "dialog",
        "aria-labelledby": titleId,
      }}
    >
      <Box className={classes.header}>
        <Box>
          <Typography id={titleId} className={classes.title}>
            {title}
          </Typography>
          {description ? (
            <Typography className={classes.description}>{description}</Typography>
          ) : null}
        </Box>
        <IconButton size="small" aria-label="Fechar filtros" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box className={classes.content}>
        {children}
        <Box className={classes.actions}>
          {onClear ? (
            <Button onClick={onClear} disabled={clearDisabled}>
              Limpar
            </Button>
          ) : null}
          <Button variant="contained" color="primary" onClick={onApply}>
            {applyLabel}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default FilterPopover;
